import service from '@/store/services/workshop/vehicle-service';

const state = {
  list: {},
  vehicle: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => { 
    state.list = list;
  },
  SET_RESOURCE: (state, vehicle) => {
    state.vehicle = vehicle;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  parking_line_list({commit, dispatch}, params) {
    return service.parking_line_list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((vehicle) => { commit('SET_RESOURCE', vehicle); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((vehicle) => { commit('SET_RESOURCE', vehicle); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((vehicle) => { commit('SET_RESOURCE', vehicle); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  vehicle: state => state.vehicle,
  page: state => state.meta.page,
};
 
const vehicle = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default vehicle;
